import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface OnDutyEntry {
  userId: string;
  firstName: string;
  lastName: string;
  color: string;
  locationName: string | null;
  shiftType: "DAILY_WAGE" | "TEMPORARY_HELP" | "HOURS";
  durationInHours: number;
  startTime?: string;
  endTime?: string;
  remainingHours?: number;
  inMinutes?: number;
}

export interface OnDutyResponse {
  success: boolean;
  onDuty: OnDutyEntry[];
  startingSoon: OnDutyEntry[];
}

export const getOnDuty = async (clientId: string): Promise<OnDutyResponse> => {
  const res = await axios.get(`${BASE_API_URL}/shifts/on-duty/${clientId}`);
  return res.data;
};
